import React, { useEffect } from "react";
import classes from "../styles/style.module.css";
import { useSelector, useDispatch } from "react-redux";
import getProfileImage from "../../../../assets/Hooks/getProfileImage";
import UserLevelProgress from "../../../../assets/components/UserLevel/Progress";
import KeyIcon from "../../../../assets/images/icons/YellowKeyIcon.svg";
import UsersRequests from "../../../../assets/services/user";
import Rcoin from "../../../../assets/images/icons/RCoin.png";

export default function MathUserSection() {
  const { currentUser, userLevel, minScore, maxScore, userPoint } = useSelector(
    ({ user }) => user
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(UsersRequests.getme());
    dispatch(UsersRequests.getUserScore());
  }, []);

  return (
    <div className={classes.userSectionContainer}>
      <div className={classes.contentContainer}>
        <div className={classes.avatar}>
          {getProfileImage(currentUser?.profileImage)}
          <div>
            <p>{currentUser?.fullName}</p>
            <div className={classes.keyContainer}>
              <img src={KeyIcon} alt="keyIcon" className={classes.keyIconImg} />
              <p>{currentUser?.coin}</p>
              <img src={Rcoin} alt="r-coin" className={classes.coinImage} />
              <p>{userPoint}</p>
            </div>
          </div>
        </div>
        <div className={classes.scoreContainer}>
          <div>
            <p>{userLevel}</p>
          </div>
          <p>طبقه</p>
        </div>
      </div>
      <UserLevelProgress />
      <div className={classes.rangeContainer}>
        <p>{maxScore}</p>
        <p>{minScore}</p>
      </div>
    </div>
  );
}
